'use client';

import { useQuery, useMutation } from '@apollo/client/react';
import {
  NOTIFICATION_PREFS_QUERY,
  SET_NOTIFICATION_PREFS_MUTATION,
  type NotificationFrequency,
  type NotificationPrefsData,
  type DocumentType,
} from '@paeffgen/react/crm-documents/data-access-graphql';

export function useNotificationPrefs() {
  const { data, loading } = useQuery<{ notificationPrefs: NotificationPrefsData }>(
    NOTIFICATION_PREFS_QUERY,
  );
  return { prefs: data?.notificationPrefs, loading };
}

export function useSetNotificationPrefs() {
  const [mutate, { loading }] = useMutation(SET_NOTIFICATION_PREFS_MUTATION, {
    refetchQueries: [{ query: NOTIFICATION_PREFS_QUERY }],
  });

  const setPrefs = (frequency: NotificationFrequency, docTypes: DocumentType[]) =>
    mutate({ variables: { frequency, docTypes } });

  return { setPrefs, loading };
}
